<p-dialog
  header="{{ contactType }} Contact Details"
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '500px' }"
  (onShow)="onShow()"
>
  <form *ngIf="form" [formGroup]="form">
    <!-- todo: come back here, job for another day; selectedTask here causes a checked after change -->
    <div *ngIf="selectedTask" class="style2023 py-3">
      <div class="flex flex-wrap grid-gap-15">
        <div class="input-group flex-grow-1">
          <div class="ui-float-label input-group-item">
            <input
              id="edit-forename"
              type="text"
              pInputText
              formControlName="forename"
              class="w-100"
            />
            <label for="edit-forename">Forename</label>
          </div>
        </div>

        <div class="input-group flex-grow-1">
          <div class="ui-float-label input-group-item">
            <input
              id="edit-surname"
              type="text"
              pInputText
              formControlName="surname"
              class="w-100"
            />
            <label for="edit-surname">Surname</label>
          </div>
        </div>
      </div>

      <div class="input-group mt-3">
        <div class="flex-grow-1">
          <div class="ui-float-label input-group-item">
            <input id="edit-email" type="text" pInputText formControlName="email" class="w-100" />
            <label for="edit-email">Email</label>
          </div>
        </div>
        <div
          *ngIf="form?.controls?.email?.errors?.email"
          class="text-danger flex-shrink-1 pt-2 pr-2"
        >
          A valid email address is required
        </div>
      </div>

      <div class="input-group mt-3">
        <div class="flex-grow-1">
          <div class="ui-float-label input-group-item">
            <input
              id="edit-secondaryEmail"
              type="text"
              pInputText
              formControlName="secondaryEmail"
              class="w-100"
            />
            <label for="edit-secondaryEmail">Secondary Email</label>
          </div>
        </div>
        <div
          *ngIf="form?.controls?.secondaryEmail?.errors?.email"
          class="text-danger flex-shrink-1 pt-2 pr-2"
        >
          A valid email address is required
        </div>
      </div>

      <div class="input-group mt-3">
        <div class="flex-grow-1">
          <div class="ui-float-label input-group-item">
            <input id="edit-phone1" type="text" pInputText formControlName="phone1" class="w-100" />
            <label for="edit-phone1">Mobile Number</label>
          </div>
        </div>
        <div *ngIf="phone1Error != ''" class="text-danger flex-shrink-1 pt-2 pr-2">
          {{ phone1Error }}
        </div>
      </div>

      <div class="input-group mt-3">
        <div class="flex-grow-1">
          <div class="ui-float-label input-group-item">
            <input id="edit-phone2" type="text" pInputText formControlName="phone2" class="w-100" />
            <label for="edit-phone2">Phone Number (alternative)</label>
          </div>
        </div>
        <div *ngIf="phone2Error != ''" class="text-danger flex-shrink-1 pt-2 pr-2">
          {{ phone2Error }}
        </div>
      </div>
    </div>
  </form>
  <p-footer class="rounded-bottom-border">
    <div class="text-right">
      <button
        type="button"
        (click)="this.onClose()"
        pButton
        label="Cancel"
        class="ui-button ui-button-tertiary"
      ></button>
      <button
        type="button"
        pButton
        label="Save"
        class="ui-button ui-button-primary"
        (click)="this.saveEditDriverNotes()"
        [disabled]="form?.invalid"
      ></button>
    </div>
  </p-footer>
</p-dialog>
